// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__lT2wB","block":"Content_block__ZRZXr","contentCenter":"Content_contentCenter__2iom2","contentStretch":"Content_contentStretch__8kP1G"};